import { useState, ReactNode, useRef } from 'react';

import { IconButton, TIconButtonProps, TIconButtonVariant } from '@treezor/design-system';

import { useOnClickOutside } from '@/hooks/useOnClickOutside';

import { IMessageAreaProps, MessageArea } from './MessageArea';

export interface IToggleTipProps extends Omit<TIconButtonProps, 'variant'>, IMessageAreaProps {
  iconVariant?: TIconButtonVariant;
  children: ReactNode;
}

export function ToggleTip({
  variant,
  placement,
  hasArrow,
  children,
  className,
  icon = 'info',
  iconVariant,
  ...rest
}: IToggleTipProps) {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside([ref], () => setIsVisible(false));

  return (
    <div ref={ref} className="relative inline-block w-fit">
      <IconButton icon={icon} variant={iconVariant} onClick={() => setIsVisible(!isVisible)} {...rest} />

      {isVisible && (
        <MessageArea variant={variant} placement={placement} hasArrow={hasArrow} className={className}>
          {children}
        </MessageArea>
      )}
    </div>
  );
}
